var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHearth = function SvgHearth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M5.234.5a4.62 4.62 0 0 0-3.351 1.441C.038 3.867.04 6.96 1.883 8.886l7.506 7.856a.4.4 0 0 0 .574 0l7.52-7.843c1.844-1.926 1.844-5.02 0-6.945a4.61 4.61 0 0 0-6.702 0L9.689 3.096 8.584 1.94A4.62 4.62 0 0 0 5.234.5Zm0 .786c1 0 1.996.403 2.77 1.21l1.391 1.455a.4.4 0 0 0 .58 0l1.386-1.448c1.549-1.616 3.999-1.616 5.547 0 1.549 1.616 1.549 4.224 0 5.84l-7.232 7.544-7.22-7.55C.91 6.72.909 4.113 2.457 2.497c.775-.808 1.778-1.21 2.778-1.21Z"
  })));
};
export default SvgHearth;